import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gossip";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:h-20 md:px-6">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap"
          aria-label="吃瓜快手首页"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full ${
              scrolled ? "bg-primary-500" : "bg-background-50/20"
            }`}
          >
            <i className="ri-water-flash-line text-lg text-background-50"></i>
          </span>
          <span
            className={`font-display text-2xl font-black tracking-wide ${
              scrolled ? "text-primary-600" : "text-background-50"
            }`}
          >
            吃瓜快手
          </span>
        </button>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={`#${link.key}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.key);
              }}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-50/90 hover:bg-background-50/20"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("newsletter");
            }}
            className={`ml-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold text-background-50 transition-all hover:opacity-90 ${
              scrolled ? "bg-primary-500" : "bg-background-50/90 text-primary-600"
            }`}
          >
            订阅今日梗
            <i className="ri-arrow-right-line"></i>
          </a>
        </nav>

        <button
          className={`flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
            scrolled ? "text-foreground-800" : "text-background-50"
          }`}
          onClick={() => setOpen(!open)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-4-line text-2xl"}></i>
        </button>
      </div>

      <div
        className={`overflow-hidden bg-background-50 transition-all duration-300 lg:hidden ${
          open ? "max-h-[420px] border-t border-background-200" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col gap-1 px-4 py-4" aria-label="移动端导航">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={`#${link.key}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.key);
              }}
              className="cursor-pointer rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => scrollTo("newsletter")}
            className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            订阅今日梗
          </button>
        </nav>
      </div>
    </header>
  );
}